// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"1e4c4b19","297":"f4d71ca5","683":"edbb8658","784":"c4087f0a","801":"9846face"}[chunkId] + ".chunk.js";
};